module.exports = __webpack_public_path__ + "static/media/digging.986bf895.svg";